function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-111.032 -97.817)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.709,21.23h0a6.014,6.014,0,0,1-4.274-1.784L1.781,12.794A6.081,6.081,0,0,1,4.52,2.617L13.577.21A6.192,6.192,0,0,1,15.166,0a5.924,5.924,0,0,1,2.712.652,6.211,6.211,0,0,1,2.091,1.739,6.026,6.026,0,0,1,1.047,5.257L18.61,16.707a5.988,5.988,0,0,1-2.26,3.335A6.205,6.205,0,0,1,12.709,21.23ZM15.1,2.268h0a3.945,3.945,0,0,0-1.016.135L7.641,4.124A3.87,3.87,0,0,0,5.9,10.6l4.724,4.725A3.87,3.87,0,0,0,17.1,13.585l1.721-6.444a3.834,3.834,0,0,0-.663-3.349A3.888,3.888,0,0,0,15.1,2.269Z",
  transform: "translate(112.879 97.817) rotate(4.992)",
  fill: "#060dd9"
}), /*#__PURE__*/React.createElement("text", {
  transform: "translate(141.118 113.683)",
  fill: "#060dd9",
  fontSize: 12,
  fontFamily: "Poppins-SemiBold, Poppins",
  fontWeight: 600,
  letterSpacing: "0.05em"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "\n    Audiozic\n")));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87.086,
    height: 22.992,
    viewBox: "0 0 87.086 22.992",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.0e606ccc.svg";
export { ForwardRef as ReactComponent };